import { render } from "./Roteiros.vue?vue&type=template&id=be86ba52&scoped=true&lang=pug"
import script from "./Roteiros.vue?vue&type=script&setup=true&lang=js"
export * from "./Roteiros.vue?vue&type=script&setup=true&lang=js"

import "./Roteiros.vue?vue&type=style&index=0&id=be86ba52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be86ba52"]])

export default __exports__